import { Link } from 'react-router-dom';

const TYPE_LABELS = {
  personal: 'Personal', investigation: 'Investigation', talent: 'Talent',
  welfare: 'Welfare', interview: 'Interview',
};
const TYPE_CLASS = {
  personal: 'type-personal', investigation: 'type-investigation',
  talent: 'type-talent', welfare: 'type-welfare', interview: 'type-interview',
};

export default function StoryCard({ story, featured, size = 'normal' }) {
  const typeClass = TYPE_CLASS[story.story_type] || 'type-personal';
  const typeLabel = TYPE_LABELS[story.story_type] || story.story_type;

  if (featured) {
    return (
      <Link to={`/stories/${story.slug}`} className="featured-card">
        {story.cover_image_url
          ? <img src={story.cover_image_url} alt={story.title} className="featured-card-img" />
          : <div style={{ height: 180, background: 'linear-gradient(135deg,rgba(0,0,0,0.2) 0%,rgba(0,0,0,0) 100%)' }} />
        }
        <div className="featured-card-body">
          <span className="featured-card-type">{typeLabel}</span>
          <h2 className="featured-card-title">{story.title}</h2>
          <p className="featured-card-excerpt">{story.excerpt.slice(0, 150)}{story.excerpt.length > 150 ? '…' : ''}</p>
          <div className="featured-card-meta">
            {story.author.first_name
              ? `${story.author.first_name} ${story.author.last_name}`
              : story.author.username
            }
            {' · '}
            {new Date(story.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
            {' · '}
            {story.read_time} min read
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/stories/${story.slug}`} className="story-card">
      {story.cover_image_url
        ? <img src={story.cover_image_url} alt={story.title} className="story-card-img" />
        : (
          <div className="story-card-img-placeholder">
            <span>📰</span>
          </div>
        )
      }
      <div className="story-card-body">
        <span className={`badge ${typeClass}`}>{typeLabel}</span>
        <h3 className="story-card-title">{story.title}</h3>
        {size !== 'compact' && (
          <p className="story-card-excerpt">
            {story.excerpt.slice(0, 110)}{story.excerpt.length > 110 ? '…' : ''}
          </p>
        )}
        <div className="story-card-meta">
          <span>
            {story.author.first_name
              ? `${story.author.first_name} ${story.author.last_name}`
              : story.author.username}
          </span>
          <span style={{ display: 'flex', gap: '0.5rem' }}>
            {story.read_time && <span>{story.read_time} min</span>}
            <span>{story.like_count ?? 0} ♥</span>
          </span>
        </div>
      </div>
    </Link>
  );
}
